import React from 'react';
export function CourseLength() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1109">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1110">
        <div className="mb-12" data-id="element-1111">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1112">
            Course Length
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1113">
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1114">
              Michigan requires an applicant to complete a minimum three hours
              of course review and a minimum of one hour live fire range time
              anytime within the six month period occurring prior to submitting
              your renewal application. Students auditing our standard CPL class
              will, at a minimum, attend the LEGAL lesson and participate in the
              range live fire exercises. Attendance for all remaining lessons is
              encouraged and allowed.
            </p>
          </div>
        </div>
      </div>
    </div>;
}